export default __webpack_public_path__ + "static/background-sample-357b8b46efbcc81228479e79c051e2f4.png";